import { render, staticRenderFns } from "./FontLargeButton.vue?vue&type=template&id=532d9bca&scoped=true&"
import script from "./FontLargeButton.ts?vue&type=script&lang=ts&"
export * from "./FontLargeButton.ts?vue&type=script&lang=ts&"
import style0 from "./FontLargeButton.css?vue&type=style&index=0&id=532d9bca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532d9bca",
  null
  
)

export default component.exports